<template>
  <div class="main-container ma-4">
    <div class="d-flex align-center justify-space-between">
      <h2 class="ma-2">Applicant Data</h2>

      <v-btn
        icon
        color="grey darken-1"
        @click="$router.push('/careers')"
        title="Back to list"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>

    <v-container fluid class="ma-2">
      <v-row>
        <v-col cols="12" md="10" class="mx-auto">
          <v-row>
            <v-col
              v-for="(col, index) in displayedColumns"
              :key="index"
              cols="12"
              md="6"
            >
              <div class="sub-title">{{ col.displayName || col.name }}</div>
              <span>{{ careerItem[col.name] }}</span>
            </v-col>
          </v-row>

          <v-row v-if="careerItem.careerCv">
            <v-col cols="12">
              <div class="sub-title">CV</div>
              <v-btn class="ma-2" :href="careerItem.careerCv" download>
                <v-icon small>mdi-download</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("careers", ["careerItem", "careerColumnsNames"]),

    careerColumns() {
      return this.careerColumnsNames.filter((a) => a.isActive);
    },

    displayedColumns() {
      return this.careerColumns.filter(
        (col) => this.careerItem && this.careerItem[col.name]
      );
    },
  },

  async mounted() {
    await this.$store.dispatch("careers/getCareerById", this.$route.params.id);
    await this.$store.dispatch("careers/loadCareerColumnsNames");
  },
};
</script>


<style lang="scss" scoped>
.main-container {
  padding-top: 2rem;
  padding-left: 1rem;
  border-radius: 1%;
  box-shadow: 0 0 10px 3px rgb(0 0 0 / 0.2);
}

.sub-header {
  font-size: 1.2rem;
  font-weight: normal;
  color: gray;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.sub-title {
  font-size: 1rem;
  font-weight: bold;
}
</style>
